import {useFarm} from 'context/farmContext';
import {useNavigate} from 'react-router-dom';

const WithCultivation = ({cultivations}) => {
  const navigate = useNavigate();
  const {updateCultivationGuid, updateCultivationArea} = useFarm();
  return (
    <>
      {cultivations?.map(item => (
        <p
          key={item.guid}
          className="my-6 text-gray-6"
          onClick={() => {
            updateCultivationGuid(item.guid, item.sub_product?.guid);
            updateCultivationArea({
              area: item.area,
              harvest_datetime: item.harvest_datetime,
            });
            item.sub_product === null
              ? navigate('/farm/add-ad/sub-product', {
                  state: {
                    product: item.mahsul.guid,
                    guid: item.guid,
                  },
                })
              : navigate('/farm/add-ad/type-ads', {
                  state: {
                    cultivationGuid: item.guid,
                  },
                });
          }}
        >
          {item.mahsul.title} - {item.farm_name}
        </p>
      ))}
    </>
  );
};

export default WithCultivation;
